import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'
import { SuggestionRequest } from 'types'

type Props = {
  designId: string
}

type Data = {
  request: SuggestionRequest
}

type Variables = {
  media_file_key: string
  topic: string
  language?: string
  media_source_override?: 'ai_video' | 'ai_image' | 'default'
}

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const regenerate = async (workspaceId: number, designId: string, variables: Variables) => {
  const res = await sendToApi(`/w/${workspaceId}/designs/${designId}/regenerate`, {
    method: 'POST',
    body: {
      media_file_key: variables.media_file_key,
      topic: variables.topic,
      language: variables.language,
      media_source_override: variables.media_source_override,
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useRegenerate = ({ designId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>((vars) => regenerate(workspaceId, designId, vars), options)
}
